import _createClass from '@babel/runtime/helpers/esm/createClass';

/* eslint-disable */
export var GROUP_COLOR_SCHEMAS = {
  GRAY: 'gray',
  ROSE: 'rose',
  MINT: 'mint',
  YELLOW: 'yellow',
  TEAL: 'teal',
  INDIGO: 'indigo',
  LILAC: 'lilac',
  TOMATO: 'tomato',
  EUCALIPTUS: 'eucaliptus'
};
var objectProperties = ['id', 'name', 'ownerOrganization', 'colorSchema', 'users'];
export var Group = /*#__PURE__*/function () {
  function Group(group) {
    // eslint-disable-next-line no-nested-ternary
    this._id = group._id ? group._id.toString() : group.id ? group.id : null;
    this._name = group.name || 'New Group';
    this._ownerOrganization = group.ownerOrganization || '';
    this._colorSchema = group.colorSchema || GROUP_COLOR_SCHEMAS.GRAY;
    this._users = group.users || [];
  }

  var _proto = Group.prototype;

  _proto.toObject = function toObject() {
    var _this = this;

    var obj = {};
    objectProperties.forEach(function (prop) {
      obj[prop] = _this[prop];
    });
    return obj;
  };

  Group.cleanGroupName = function cleanGroupName(groupName) {
    var nameTrimed = groupName.trim();
    return nameTrimed[0] === '.' ? nameTrimed.slice(1).trim() : nameTrimed;
  };

  Group.isGroupNameInvalid = function isGroupNameInvalid(groupName) {
    return groupName.length > 64 || /[,+"<>\\]/.test(groupName);
  };

  _createClass(Group, [{
    key: 'id',
    get: function get() {
      return this._id;
    },
    set: function set(id) {
      this._id = id;
    }
  }, {
    key: 'name',
    get: function get() {
      return this._name;
    },
    set: function set(name) {
      var nameTrimed = name.trim();
      this._name = nameTrimed[0] === '.' ? nameTrimed.slice(1).trim() : nameTrimed;
    }
  }, {
    key: 'ownerOrganization',
    get: function get() {
      return this._ownerOrganization;
    },
    set: function set(orgId) {
      this._ownerOrganization = orgId;
    }
  }, {
    key: 'colorSchema',
    get: function get() {
      return this._colorSchema;
    },
    set: function set(colorSchema) {
      if (!GROUP_COLOR_SCHEMAS[colorSchema.toUpperCase()]) {
        return false;
      }

      this._colorSchema = colorSchema;
      return true;
    }
  }, {
    key: 'users',
    get: function get() {
      return this._users;
    },
    set: function set(users) {
      this._users = users;
    }
  }]);

  return Group;
}();